import axios, { AxiosResponse, AxiosError } from 'axios';
import CognitoRefreshUser from '../auth/cognito-refresh-user';
import { getCognitoStore } from '../auth/cognito-store';

function baseUrl() {
  let path = location.hostname === 'staging-allianceautogasfuelingportal.kinsta.cloud' ? 'beta' : 'v1';
  return `https://u3mchr0zmk.execute-api.us-east-1.amazonaws.com/${path}`;
}

/**
 * The base url path for the AWS Api gateway
 */
export const awsApiInstance = axios.create({
  baseURL: baseUrl(),
  headers: {
    'Content-type': 'application/json'
  }
});

awsApiInstance.interceptors.request.use( 
  request => {
    const { IdToken } = getCognitoStore();

    request.headers.Authorization = IdToken;

    return request;
  }, (error: AxiosError) => {
    Promise.reject(error);
});

awsApiInstance.interceptors.response.use(response => {
  return response
}, async error => {
  const originalRequest = error.config;
  const submitSpinner = document.querySelector('.aafp_submit-spinner') as HTMLElement;  

  if (error.message && error.message.includes('Network Error') && !error.response) {
    console.error('CORS errors: ', error.message);
    submitSpinner?.classList.remove('aafp_button-loading');
    return Promise.reject(new Error('CORS error: Please check your network connection or server configuration.'));
  }

  if (error.response.status === 401 && !originalRequest._retry) {
    originalRequest._retry = true;
    try {
      const response = await CognitoRefreshUser();
      const parsedData = JSON.parse(response.body);
      const { idToken } = parsedData;
      originalRequest.headers.Authorization = idToken;
      return awsApiInstance.request(originalRequest);
    } catch (refreshError) {
      return Promise.reject(refreshError);
    }
  }
  if (error.response) {
    return Promise.reject(error.response.data); // Return only the error data
  }
  return Promise.reject(error);
});

export const responseBody = (response: AxiosResponse) => response.data;